import { render, staticRenderFns } from "./server-console.vue?vue&type=template&id=07835d9a&scoped=true&"
import script from "./server-console.vue?vue&type=script&lang=js&"
export * from "./server-console.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07835d9a",
  null
  
)

export default component.exports